// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"fdee0e06","116":"7b454095","381":"632a6ea4","471":"5b6dd85b","633":"dbd8b8ef","876":"c2b26258"}[chunkId] + ".chunk.css";
};